import React, { useMemo } from "react";
import { connect } from "react-redux";

import MapActioner from "services/map/actioner";
import NonMovingCarsActioner from "services/nonMovingCars/actioner";

import HalfLayout from "components/HalfLayout";
import Map from "components/Map";

import MapComponent from "scenes/NonMovingCars/components/MapComponent";
import NonMovingCarsLayout from "scenes/NonMovingCars/components/NonMovingCarsLayout";

function NonMovingCars({ retrieveNonMovingCars, setCenterToDefault, items }) {
  const toggleSpaceLabels = useMemo(() => {
    return (
      items?.some((car) => car?.meta_data?.client?.label !== undefined) ?? false
    );
  }, [items]);

  return (
    <HalfLayout
      leftComponent={<NonMovingCarsLayout />}
      rightComponent={
        <Map
          floorsButton
          mapComponent={<MapComponent onRecenter={setCenterToDefault} />}
          onReloadData={retrieveNonMovingCars}
          onRecenter={setCenterToDefault}
          withCheckboxOptions={{
            aisles: false,
            labels: false,
            displays: false,
            spaceLabels: toggleSpaceLabels,
          }}
        />
      }
    />
  );
}

const mapDispatchToProps = (dispatch) => ({
  retrieveNonMovingCars: () =>
    dispatch(NonMovingCarsActioner.retrieveList("radius")),
  setCenterToDefault: () => dispatch(MapActioner.setCenterToDefault()),
});

const mapStateToProps = (state) => ({
  items: state.NonMovingCars.list.items,
});

export default connect(mapStateToProps, mapDispatchToProps)(NonMovingCars);
